/**
 * Navigation configuration per role
 * Each role has its own set of navigation items
 */

export const navigationConfig = {
  admin: [
    { path: '/dashboard', labelKey: 'admin.dashboard', icon: '📊' },
    { path: '/properties', labelKey: 'admin.properties', icon: '🏠' },
    { path: '/offers', labelKey: 'admin.offers', icon: '🎁' },
    { path: '/vendors', labelKey: 'admin.vendors', icon: '🏪' },
    { path: '/owners', labelKey: 'admin.owners', icon: '👤' },
    { path: '/categories', labelKey: 'admin.categories', icon: '📁' },
    { path: '/reviews', labelKey: 'admin.reviews', icon: '⭐' },
    { path: '/translations', labelKey: 'admin.translations', icon: '🌐' },
    { path: '/approvals', labelKey: 'admin.pendingApprovals', icon: '⏳', showBadge: true },
  ],
  owner: [
    { path: '/dashboard', labelKey: 'owner.myProperties', icon: '🏠' },
    { path: '/custom-offers', labelKey: 'owner.customOffers', icon: '🎁' },
    { path: '/settings', labelKey: 'owner.settings', icon: '⚙️' },
  ],
  vendor: [
    { path: '/dashboard', labelKey: 'vendor.dashboard', icon: '📊' },
    { path: '/my-offers', labelKey: 'vendor.myOffers', icon: '🎁' },
    { path: '/redemptions', labelKey: 'vendor.redemptions', icon: '🎫' },
    { path: '/vendor-settings', labelKey: 'vendor.settings', icon: '⚙️' },
  ],
};

/**
 * Get navigation items for a specific role
 * @param {string} role - User role (admin, owner, vendor)
 * @returns {Array} Navigation items for the role
 */
export function getNavigationForRole(role) {
  return navigationConfig[role] || [];
}
